import { getAsset } from '../../../../../../../util/assets';

export const WALDOFICATION_FEATURES = [
  {
    id: 'AI_TAG',
    label: 'AI-powered photo delivery to your guests',
    howItWorks: {
      header:
        'Save time. Save sanity. Secure Al-powered photo delivery to everyone',
      assetUrl: getAsset('/photo-delivery-how-it-works.gif'),
    },
  },
  'Printable QR signage (easy uploading!)',
  'Custom SMS code for easy joining',
  {
    id: 'LIVE_SLIDESHOW',
    label: 'Live slideshow',
    howItWorks: {
      header:
        'Share photos on the big screen in real-time. Perfect for your wedding day reception!',
      assetUrl: getAsset('/live-slideshows-how-it-works.gif'),
    },
  },
  'Contributor photo moderation',
  'Bulk guest list import & invites',
  '50GB of storage for a year',
];
